export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";